import React, { Component, PropTypes } from 'react';
import classNames from 'classnames';
import { COLOR_STYLE } from '../../constants/FRNBaseStyles';

/**
 * Class representing section headings for the site
 */
class ReadMoreButton extends Component {
  static propTypes = {
    text: PropTypes.string,
    fullWidth: PropTypes.bool,
    roundedCorner: PropTypes.oneOf(['slight', 'strong', 'no']),
    fontStyle: PropTypes.oneOf(['uppercase', 'regular']),
    backgroundColor: PropTypes.string,
    backgroundColorStyle: PropTypes.oneOf(Object.keys(COLOR_STYLE)),
    buttonStyle: PropTypes.oneOf(['solid', 'outline']),
    outlineColor: PropTypes.string,
    outlineColorStyle: PropTypes.oneOf(Object.keys(COLOR_STYLE)),
    urlTarget: PropTypes.string,
    textColor: PropTypes.string,
    textColorStyle: PropTypes.oneOf(Object.keys(COLOR_STYLE)),
    showMoreArrow: PropTypes.bool,
    link: PropTypes.string
  }

  static defaultProps = {
    text: 'Read More',
    fontStyle: 'uppercase'
  }

  render() {
    const {
      text,
      fullWidth,
      roundedCorner,
      fontStyle,
      buttonStyle,
      backgroundColor,
      backgroundColorStyle,
      outlineColor: borderColor,
      outlineColorStyle,
      textColor: color,
      textColorStyle,
      urlTarget: target,
      link: href,
      showMoreArrow
    } = this.props;

    const style = {
      backgroundColor,
      color,
      borderColor
    };

    const className = classNames(
      'ReadMoreButton',
      {[`ReadMoreButton-border--${roundedCorner}`]: roundedCorner},
      [`ReadMoreButton-style--${buttonStyle || 'basic'}`],
      `ReadMoreButton-text--${fontStyle}`,
      {'ReadMoreButton--icon': showMoreArrow},
      {'ReadMoreButton-width--fullWidth': fullWidth},
      {[`frn-u-foreground-${textColorStyle}`]: textColorStyle && buttonStyle},
      {[`frn-u-background-${backgroundColorStyle}`]: backgroundColorStyle && buttonStyle},
      {[`frn-u-outline-${outlineColorStyle}`]: outlineColorStyle && buttonStyle}
    );

    return (
      <div className={className} style={style}>
        <a href={href} target={target} role="button">
          {text}
          <i className="fa fa-chevron-circle-right"></i>
        </a>
      </div>
    );
  }

}

export default ReadMoreButton;



// WEBPACK FOOTER //
// ./app/components/shared/ReadMoreButton.js